import React, { useState, useEffect } from 'react';
import './App.css';

// NOTE: APP_VERSION auto-managed by build-main-bitcoin-calculator.sh using version.txt
const APP_VERSION = "BitcoinAgree Calculator V0.1.15"; // do not edit manually
const THEME_KEY = 'bitcoinagree_theme';

function getCookie(name) {
  const parts = document.cookie.split(';').map(function(part) { return part.trim(); });
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].indexOf(name + '=') === 0) {
      return decodeURIComponent(parts[i].substring(name.length + 1));
    }
  }
  return '';
}

function getCookieDomain() {
  const host = window.location.hostname;
  if (host === 'bitcoinagree.com' || host.endsWith('.bitcoinagree.com')) return '.bitcoinagree.com';
  if (host === 'test.local' || host.endsWith('.test.local')) return '.test.local';
  return '';
}

function getStoredThemeMode() {
  const cookieMode = getCookie(THEME_KEY);
  if (cookieMode === 'auto' || cookieMode === 'light' || cookieMode === 'dark') return cookieMode;
  try {
    const localMode = window.localStorage.getItem(THEME_KEY);
    if (localMode === 'auto' || localMode === 'light' || localMode === 'dark') return localMode;
  } catch(e) {}
  return 'auto';
}

function resolveTheme(mode) {
  if (mode === 'light' || mode === 'dark') return mode;
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch(e) {
    return 'light';
  }
}

function saveThemeMode(mode) {
  try { window.localStorage.setItem(THEME_KEY, mode); } catch(e) {}
  const domain = getCookieDomain();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  const domainPart = domain ? '; Domain=' + domain : '';
  document.cookie = THEME_KEY + '=' + encodeURIComponent(mode) + '; Max-Age=31536000; Path=/; SameSite=Lax' + domainPart + secure;
}

function getThemeTokens(theme) {
  if (theme === 'dark') {
    return {
      bg: '#101418',
      surface: '#171d24',
      surfaceSoft: '#202832',
      text: '#edf2f7',
      muted: '#a8b3c2',
      border: '#334152',
      bitcoin: '#f7a531',
      bitcoinStrong: '#ffc46b',
      focus: '#7aa7ff',
      danger: '#ff8a80'
    };
  }
  return {
    bg: '#f6f8fb',
    surface: '#ffffff',
    surfaceSoft: '#f8fafc',
    text: '#17202a',
    muted: '#52616f',
    border: '#d8e0ea',
    bitcoin: '#f7931a',
    bitcoinStrong: '#b96000',
    focus: '#2563eb',
    danger: '#b42318'
  };
}

function getHomeHref() {
  try {
    const h = window.location.host;
    if(h.endsWith('.test.local') || h === 'test.local' || h.startsWith('localhost')) return 'http://test.local/';
  } catch(e){}
  return 'https://bitcoinagree.com/';
}

function getThemeHref() {
  try {
    const h = window.location.host;
    if(h.endsWith('.test.local') || h === 'test.local' || h.startsWith('localhost')) return 'http://theme.test.local/';
  } catch(e){}
  return 'https://theme.bitcoinagree.com/';
}

function getApiBase() {
  try {
    const h = window.location.host;
    if(h.endsWith('.test.local') || h === 'test.local' || h.startsWith('localhost') || h.startsWith('127.0.0.1')) {
      return "http://bitcoin.api.test.local/v1/";
    }
  } catch(e){}
  return "https://bitcoin.api.bitcoinagree.com/v1/";
}

function SiteFooter(props) {
  const tokens = props.tokens;
  const footerLinkStyle = {
    color: tokens.bitcoinStrong,
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 28,
    textDecorationColor: tokens.border,
    textUnderlineOffset: 3
  };
  const groups = [
    {
      title: 'Services',
      links: [
        { href: getHomeHref(), label: 'BitcoinAgree' },
        { href: getThemeHref(), label: 'Theme Lab' }
      ]
    },
    {
      title: 'Community',
      links: [
        { href: 'https://www.reddit.com/r/bitcoinagree/', label: 'Reddit', external: true },
        { href: 'https://x.com/bitcoinagree', label: 'X (Twitter)', external: true },
        { href: 'https://www.youtube.com/@bitcoinagree', label: 'YouTube', external: true },
        { href: 'https://github.com/bitcoinagree', label: 'GitHub', external: true }
      ]
    },
    {
      title: 'Info',
      links: [
        { href: '', label: 'Privacy Policy' },
        { href: '', label: 'Terms of Service' },
        { href: '', label: 'Contact' }
      ]
    }
  ];

  return (
    <footer className="site-footer" style={{color: tokens.muted, borderTop: '1px solid ' + tokens.border}}>
      <div className="site-footer-grid">
        {groups.map(function(group) {
          return (
            <div className="site-footer-group" key={group.title}>
              <div className="site-footer-title" style={{color: tokens.text}}>{group.title}</div>
              <div className="site-footer-links">
                {group.links.map(function(item) {
                  return (
                    <a
                      href={item.href}
                      key={item.label}
                      style={footerLinkStyle}
                      target={item.external ? '_blank' : undefined}
                      rel={item.external ? 'noopener noreferrer' : undefined}
                    >
                      {item.label}
                    </a>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      <div className="site-footer-bottom">
        <div className="site-footer-nostr" style={{color: tokens.bitcoinStrong}}>
          Find me on Nostr: bitcoinagree@bitcoinagree.com
        </div>
        <a
          href="https://primal.net/p/nprofile1qqsgquzttv6xac0ft4f7lspqsdfkg4dmalz2f5hpyc59c2yk5qv0xacrp8zm5"
          target="_blank"
          rel="noopener noreferrer"
          style={footerLinkStyle}
        >
          Primal
        </a>
        <div className="site-footer-made">
          Made with 🧡 by <span style={{color: tokens.bitcoinStrong, fontWeight: 700}}>BitcoinAgree</span>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  // Precise terminal issuance (cannot reach full 21M due to integer satoshis): 20,999,999.9769 BTC
  const TOTAL_SUPPLY = 20999999.9769;
  const MAX_SATS = Math.floor(TOTAL_SUPPLY * 100000000); // 2,099,999,997,690,000
  const [price, setPrice] = useState(null);
  const [livePrice, setLivePrice] = useState(null);
  const [priceInput, setPriceInput] = useState('');
  const [priceFocused, setPriceFocused] = useState(false);
  const [btc, setBtc] = useState('1');
  const [usd, setUsd] = useState('');
  const [sats, setSats] = useState(''); // integer string
  const [pct, setPct] = useState(''); // percentage of total supply
  const [btcFocused, setBtcFocused] = useState(false);
  const [usdFocused, setUsdFocused] = useState(false);
  const [satsFocused, setSatsFocused] = useState(false);
  const [pctFocused, setPctFocused] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastEdited, setLastEdited] = useState('btc'); // 'btc' | 'usd' | 'sats' | 'pct'
  const [themeMode, setThemeMode] = useState(getStoredThemeMode());
  const [resolvedTheme, setResolvedTheme] = useState(resolveTheme(themeMode));

  function formatPctFromBtc(b){
    if(!b) return '';
    const pct = (b / TOTAL_SUPPLY) * 100;
    let s;
    if(pct < 1e-10) {
      s = pct.toFixed(14); // very small → 14 decimals
    } else {
      s = pct.toFixed(10);
    }
    s = s.replace(/0+$/,'').replace(/\.$/,'');
    return s === '' ? '0' : s;
  }
  function formatPctDisplay(pctStr){
    if(pctStr === '') return '';
    const num = Number(pctStr);
    if(!isFinite(num)) return pctStr;
    if(num === 0) return '0';
  // Always show plain decimal (no scientific) for tiny values
  if(num < 1e-10) return num.toFixed(14).replace(/0+$/,'').replace(/\.$/,'');
    return num.toLocaleString(undefined,{maximumFractionDigits:10});
  }
  function formatUsdPrice(v){
    const num = Number(v);
    if(!isFinite(num)) return '';
    return num.toLocaleString(undefined,{minimumFractionDigits:2, maximumFractionDigits:2});
  }
  function setActivePriceFromRaw(raw){
    const cleaned = normalize(raw);
    setPriceInput(cleaned);
    const n = parseFloat(stripCommas(cleaned)||'0');
    if(!isNaN(n) && n > 0) {
      setPrice(n);
    } else if(cleaned === '') {
      setPrice(null);
    }
  }

  useEffect(() => {
    // Older react-scripts version lacks optional chaining support; avoid ?. syntax
    const m = APP_VERSION.match(/V[0-9]+\.[0-9]+\.[0-9]+/);
    document.title = ("Bitcoin Calculator " + (m ? m[0] : "")).trim();
    let cancelled = false;
    setLoading(true); setError(null);
    fetch(getApiBase())
      .then(r => { if(!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(data => {
        if(!cancelled){
          setLivePrice(data.usd);
          setPrice(data.usd);
          setPriceInput(String(data.usd));
        }
      })
      .catch(e => { if(!cancelled){ setError(e.message); }} )
      .finally(()=>{ if(!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    function apply() {
      const nextTheme = resolveTheme(themeMode);
      setResolvedTheme(nextTheme);
      document.documentElement.setAttribute('data-theme', nextTheme);
      document.documentElement.setAttribute('data-theme-mode', themeMode);
      saveThemeMode(themeMode);
    }
    apply();
    let media;
    try {
      media = window.matchMedia('(prefers-color-scheme: dark)');
      if (themeMode === 'auto') {
        if (media.addEventListener) media.addEventListener('change', apply);
        else if (media.addListener) media.addListener(apply);
      }
    } catch(e) {}
    return () => {
      if (media && themeMode === 'auto') {
        if (media.removeEventListener) media.removeEventListener('change', apply);
        else if (media.removeListener) media.removeListener(apply);
      }
    };
  }, [themeMode]);

  useEffect(() => {
    function syncThemeMode(event) {
      if (event && event.type === 'storage' && event.key !== THEME_KEY) return;
      const nextMode = getStoredThemeMode();
      setThemeMode(function(currentMode) {
        return currentMode === nextMode ? currentMode : nextMode;
      });
    }
    window.addEventListener('storage', syncThemeMode);
    window.addEventListener('focus', syncThemeMode);
    return function() {
      window.removeEventListener('storage', syncThemeMode);
      window.removeEventListener('focus', syncThemeMode);
    };
  }, []);

  // When price loads or changes, recompute dependent fields from the last edited source.
  useEffect(() => {
    if(price == null) return;
    if(lastEdited === 'btc') {
      const n = parseFloat(btc||'0');
      if(!isNaN(n)) {
  const clamped = Math.min(n, TOTAL_SUPPLY);
        if(clamped !== n) {
          const btcStr = clamped.toFixed(8).replace(/0+$/,'').replace(/\.$/,'');
          setBtc(btcStr);
        }
        setUsd((clamped*price).toFixed(2));
        setSats(Math.round(clamped*100000000).toString());
  setPct(formatPctFromBtc(clamped));
      }
    } else if(lastEdited === 'usd') {
      const n = parseFloat(usd||'0');
      if(!isNaN(n) && price) {
        const btcVal = n/price;
        const btcStr = btcVal.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
  const clamped = Math.min(btcVal, TOTAL_SUPPLY);
  const btcClampedStr = clamped.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
  setBtc(btcClampedStr);
  setSats(Math.round(clamped*100000000).toString());
  setPct(formatPctFromBtc(clamped));
      }
    } else if(lastEdited === 'sats') {
      const n = parseInt(sats||'0',10);
      if(!isNaN(n)) {
  const satClamped = Math.min(n, MAX_SATS);
  if(satClamped !== n) setSats(satClamped.toString());
  const btcVal = satClamped/100000000;
  const btcStr = btcVal.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
  setBtc(btcStr);
  setUsd((btcVal*price).toFixed(2));
  setPct(formatPctFromBtc(btcVal));
      }
    } else if(lastEdited === 'pct') {
      const n = parseFloat(pct||'0');
      if(!isNaN(n)) {
  const pctClamped = Math.min(n,100);
  if(pctClamped !== n) setPct(pctClamped.toString());
  const btcVal = (pctClamped/100) * TOTAL_SUPPLY;
        const btcStr = btcVal.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
        setBtc(btcStr);
        setSats(Math.round(btcVal*100000000).toString());
        setUsd((btcVal*price).toFixed(2));
      }
    }
  }, [price]);

  function stripCommas(v){ return v.replace(/,/g,''); }
  function formatWithCommas(v, opts){
    if(v === '' || v === '.' || v === '-') return v;
    const num = Number(v); if(isNaN(num)) return v; return num.toLocaleString(undefined, opts);
  }
  function normalize(v){
    v = v.trim(); if(v==='') return ''; v = stripCommas(v);
    if(!/^\d*(\.\d*)?$/.test(v)) return v; return v;
  }
  const onBtc = e => {
    const raw = normalize(e.target.value); setBtc(raw); setLastEdited('btc');
    const n = parseFloat(stripCommas(raw)||'0');
    if(!isNaN(n)) {
      const clamped = Math.min(n, TOTAL_SUPPLY);
      if(clamped !== n) {
        const btcStr = clamped.toFixed(8).replace(/0+$/,'').replace(/\.$/,'');
        setBtc(btcStr);
      }
  setSats(clamped? Math.round(clamped*100000000).toString() : '');
  if(price!=null) setUsd((clamped*price).toFixed(2));
  setPct(formatPctFromBtc(clamped));
    } else {
      setSats('');
      if(price!=null) setUsd('');
      setPct('');
    }
  };
  const onUsd = e => {
    const raw = normalize(e.target.value); setUsd(raw); setLastEdited('usd');
    const n = parseFloat(stripCommas(raw)||'0');
    if(!isNaN(n) && price){
      const btcVal = n/price;
      const clamped = Math.min(btcVal, TOTAL_SUPPLY);
      const btcStr = clamped.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
  setBtc(btcStr);
  setSats(Math.round(clamped*100000000).toString());
  setPct(formatPctFromBtc(clamped));
    }
  };
  const onSats = e => {
    let raw = e.target.value.replace(/,/g,'').trim();
    if(raw === '') { setSats(''); setLastEdited('sats'); if(price!=null) setUsd(''); setBtc(''); setPct(''); return; }
    if(!/^\d+$/.test(raw)) return; // only integers
    setSats(raw); setLastEdited('sats');
    const satInt = parseInt(raw,10);
    if(!isNaN(satInt)){
      const satClamped = Math.min(satInt, MAX_SATS);
      if(satClamped !== satInt) setSats(satClamped.toString());
      const btcVal = satClamped/100000000;
      const btcStr = btcVal.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
  setBtc(btcStr);
  if(price!=null) setUsd((btcVal*price).toFixed(2));
  setPct(formatPctFromBtc(btcVal));
    }
  };
  const onPct = e => {
    const raw = normalize(e.target.value); setPct(raw); setLastEdited('pct');
    const n = parseFloat(stripCommas(raw)||'0');
    if(!isNaN(n)) {
      const pctClamped = Math.min(n,100);
      if(pctClamped !== n) setPct(pctClamped.toString());
      const btcVal = (pctClamped/100) * TOTAL_SUPPLY;
      const btcStr = btcVal.toFixed(8).replace(/0+$/,'').replace(/\.$/,'') || '0';
  setBtc(btcStr);
  setSats(Math.round(btcVal*100000000).toString());
  if(price!=null) setUsd((btcVal*price).toFixed(2));
    }
  };

  const tokens = getThemeTokens(resolvedTheme);
  const appStyle = {minHeight:'100vh', background:tokens.bg, color:tokens.text, fontFamily:'Arial, sans-serif', padding:'28px 16px 32px'};
  const pageStyle = {maxWidth:900, margin:'0 auto'};
  const toolPanelStyle = {border:'1px solid ' + tokens.border, borderRadius:8, padding:18, background:tokens.surface};
  const panelStyle = {border:'1px solid ' + tokens.border, borderRadius:8, padding:16, background:tokens.surfaceSoft};
  const gridStyle = {display:'grid', gap:12, gridTemplateColumns:'repeat(2, minmax(0, 1fr))', width:'100%'};
  const fieldStyle = {display:'flex', flexDirection:'column', fontSize:14, flex:'1 1 190px', minWidth:0};
  const inputStyle = {width:'100%', boxSizing:'border-box', fontSize:17, padding:'9px 10px', border:'1px solid ' + tokens.border, borderRadius:6, background:tokens.surface, color:tokens.text};
  const priceInputStyle = Object.assign({}, inputStyle, {minWidth:0});
  const buttonStyle = {border:'1px solid ' + tokens.bitcoin, borderRadius:6, background:tokens.surfaceSoft, color:tokens.bitcoinStrong, cursor:'pointer', fontSize:14, fontWeight:600, padding:'9px 12px', whiteSpace:'nowrap'};
  const activeButtonStyle = Object.assign({}, buttonStyle, {background:tokens.bitcoin, color:'#111827', fontWeight:700});
  const modeButtonStyle = Object.assign({}, buttonStyle, {alignItems:'center', boxSizing:'border-box', display:'inline-flex', height:44, justifyContent:'center', padding:0, width:68});
  const activeModeButtonStyle = Object.assign({}, modeButtonStyle, {background:tokens.bitcoin, color:'#111827', fontWeight:700});
  const priceIsManual = livePrice != null && price != null && Math.abs(price - livePrice) > 0.000001;
  const modes = ['auto', 'light', 'dark'];
  const domainName = (function(){
    try { return window.location.hostname || 'calculator.bitcoinagree.com'; } catch(e) { return 'calculator.bitcoinagree.com'; }
  })();

  return (
    <div style={appStyle}>
    <div style={pageStyle}>
      <header className="site-header">
        <div>
          <a href={getHomeHref()} style={{color:tokens.bitcoinStrong, textDecoration:'none', fontWeight:700}}>BitcoinAgree</a>
          <h1 className="site-title">Bitcoin Calculator</h1>
          <div style={{fontSize:13, color:tokens.muted}}>{domainName}</div>
        </div>
        <div className="theme-mode-control">
          {modes.map(function(mode) {
            return <button key={mode} type="button" style={themeMode === mode ? activeModeButtonStyle : modeButtonStyle} onClick={function(){ setThemeMode(mode); }}>{mode.charAt(0).toUpperCase() + mode.slice(1)}</button>;
          })}
        </div>
      </header>
      <div className="calculator-card" style={toolPanelStyle}>
        <div style={{display:'flex', flexDirection:'column', gap:16}}>
        <div style={panelStyle}>
          <label style={{display:'flex', flexDirection:'column', fontSize:14, gap:6}}>
            USD per BTC
            <div className="price-row" style={{display:'flex', gap:10, alignItems:'stretch', flexWrap:'wrap'}}>
              <input
                style={priceInputStyle}
                type="text"
                inputMode="decimal"
                value={priceFocused ? priceInput : formatWithCommas(priceInput,{minimumFractionDigits:2, maximumFractionDigits:2})}
                onChange={e=>setActivePriceFromRaw(e.target.value)}
                onFocus={()=>setPriceFocused(true)}
                onBlur={()=>setPriceFocused(false)}
                placeholder={loading ? 'Loading live price...' : 'Enter BTC price'}
              />
              <button
                type="button"
                style={buttonStyle}
                disabled={livePrice == null}
                onClick={()=>{
                  if(livePrice != null) {
                    setPrice(livePrice);
                    setPriceInput(String(livePrice));
                  }
                }}
              >
                Use live
              </button>
            </div>
          </label>
          <div style={{fontSize:12, color:tokens.muted, marginTop:8, display:'flex', gap:8, flexWrap:'wrap'}}>
            {loading && <span>Loading live price...</span>}
            {error && <span style={{color:tokens.danger}}>Error: {error}</span>}
            {!loading && !error && livePrice!=null && <span>Live: 1 BTC = ${livePrice.toLocaleString()}</span>}
            {priceIsManual && <span style={{color:tokens.bitcoinStrong}}>Manual price active</span>}
          </div>
        </div>

        <div className="calculator-field-grid" style={gridStyle}>
          <label style={fieldStyle}>
            BTC
            <input
              style={inputStyle}
              type="text"
              inputMode="decimal"
              value={btcFocused ? btc : formatWithCommas(btc,{maximumFractionDigits:8})}
              onChange={onBtc}
              onFocus={()=>setBtcFocused(true)}
              onBlur={()=>setBtcFocused(false)}
            />
          </label>
          <label style={fieldStyle}>
            USD
            <input
              style={inputStyle}
              type="text"
              inputMode="decimal"
              value={usdFocused ? usd : formatWithCommas(usd,{minimumFractionDigits:2, maximumFractionDigits:2})}
              onChange={onUsd}
              onFocus={()=>setUsdFocused(true)}
              onBlur={()=>setUsdFocused(false)}
            />
          </label>
        </div>
          <div className="calculator-field-grid" style={gridStyle}>
            <label style={fieldStyle}>
              SATOSHI
              <input
                style={inputStyle}
                type="text"
                inputMode="numeric"
                value={satsFocused ? sats : formatWithCommas(sats,{maximumFractionDigits:0})}
                onChange={onSats}
                onFocus={()=>setSatsFocused(true)}
                onBlur={()=>setSatsFocused(false)}
              />
            </label>
            <label style={fieldStyle}>
              SUPPLY %
              <input
                style={inputStyle}
                type="text"
                inputMode="decimal"
                value={pctFocused ? pct : formatPctDisplay(pct)}
                onChange={onPct}
                onFocus={()=>setPctFocused(true)}
                onBlur={()=>setPctFocused(false)}
              />
            </label>
          </div>
  <div style={panelStyle}>
          <div style={{minHeight:32, display:'flex', flexDirection:'column', gap:6, textAlign:'left', width:'100%'}}>
          {!loading && !error && price!=null && <span style={{fontSize:12, color:tokens.muted}}>Calculating with 1 BTC = ${formatUsdPrice(price)}</span>}
            <div style={{fontSize:12, color:tokens.muted, lineHeight:1.35}}>
              <div>Use this tool to:</div>
              <div>1) Convert BTC to USD at the live or manual price.</div>
              <div>2) Convert USD to BTC at the live or manual price.</div>
              <div>3) Convert Satoshi to USD (and back).</div>
              <div>4) View / edit % of total BTC supply.</div>
              <div>Terminal BTC supply: 20,999,999.9769 BTC (inputs are capped).</div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <SiteFooter tokens={tokens} />
    </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/App.js